import React, { Component } from "react";

import { Input } from "@rocketseat/unform";
import MaskedField from "../../../../components/MaskedField";

import { Row, Col } from "antd";

import axios from "axios";

import cpfMask from "../../../../components/Masks/Cpf";
import phoneMask from "../../../../components/Masks/Phone";
import cepMask from "../../../../components/Masks/CEP";

export default class BForm extends Component {
  /** Campos para cadastro de informações do causador/segurado */

  state = {
    cpf_condutor: "",
    cpf_proprietario: "",
    mask_cpf_cond: cpfMask(""),
    mask_cpf_prop: cpfMask("")
  };

  /** Evento chamado quando o campo de CPF do condutor é alterado */
  handleCondCpfCnpj = event => {
    this.setState({
      cpf_condutor: event.target.value,
      mask_cpf_cond: cpfMask(event.target.value)
    });
  };

  /** Evento chamado quando o campo de CPF do proprietário é alterado */
  handlePropCpfCnpj = event => {
    this.setState({
      cpf_proprietario: event.target.value,
      mask_cpf_prop: cpfMask(event.target.value)
    });
  };

  /** Obtém um endereço através do CEP */
  handleCepInformations = (event, owner) => {
    let cep = event.target.value;
    if (cep.length == 9) {
      let clearCep = cep.replace(/[^0-9]/g, "");

      axios.get(`http://viacep.com.br/ws/${clearCep}/json`).then(response => {
        const data = response.data;
        if (!data.erro) {
          const logradouro = data.logradouro;
          const complemento = data.complemento;
          const bairro = data.bairro;
          const localidade = data.localidade;
          const uf = data.uf;

          document.getElementById(`${owner}_rua`).value = logradouro;
          document.getElementById(`${owner}_complemento`).value = complemento;
          document.getElementById(`${owner}_bairro`).value = bairro;
          document.getElementById(`${owner}_uf`).value = uf;
          document.getElementById(`${owner}_cidade`).value = localidade;
        }
      });
    }
  };

  render() {
    /** Campos do formulário do filtro verde */
    return (
      <div>
        <div className="filtro__info_container filtro__condutor">
          <div className="filtro__title">Informações do Condutor</div>
          <div className="p-2">
            <Row gutter={8}>
              <Col span={12}>
                <div className="d-flex mb-2">
                  <label>Nome:</label>
                  <Input
                    className="ant-input"
                    name="condutor_nome"
                    type="text"
                  />
                </div>
                <div className="d-flex mb-2">
                  <label>Endereço:</label>
                  <Input
                    className="ant-input"
                    name="condutor_rua"
                    type="text"
                  />
                </div>
                <div className="d-flex mb-2">
                  <label>Complemento:</label>
                  <Input
                    className="ant-input"
                    name="condutor_complemento"
                    type="text"
                  />
                </div>
                <div className="d-flex mb-2">
                  <label>Cidade:</label>
                  <Input
                    className="ant-input"
                    name="condutor_cidade"
                    type="text"
                  />
                </div>
                <div className="d-flex mb-2">
                  <label>CEP:</label>
                  <MaskedField
                    className="ant-input"
                    name="condutor_cep"
                    type="text"
                    mask={cepMask()}
                    customfunction={event =>
                      this.handleCepInformations(event, "condutor")
                    }
                  />
                </div>
              </Col>
              <Col span={12}>
                <div className="d-flex mb-2">
                  <label>CPF/CNPJ:</label>
                  <MaskedField
                    className="ant-input"
                    name="condutor_cpf_cnpj"
                    type="text"
                    mask={this.state.mask_cpf_cond}
                    customfunction={event => this.handleCondCpfCnpj(event)}
                  />
                </div>
                <div className="d-flex mb-2">
                  <label>Nº:</label>
                  <Input
                    className="ant-input"
                    name="condutor_numero"
                    type="text"
                  />
                </div>
                <div className="d-flex mb-2">
                  <label>Bairro:</label>
                  <Input
                    className="ant-input"
                    name="condutor_bairro"
                    type="text"
                  />
                </div>
                <div className="d-flex mb-2">
                  <label>UF:</label>
                  <Input className="ant-input" name="condutor_uf" type="text" />
                </div>
                <div className="d-flex mb-2">
                  <label>Telefone 1:</label>
                  <MaskedField
                    className="ant-input"
                    name="condutor_telefone_1"
                    type="text"
                    mask={phoneMask()}
                  />
                </div>
                <div className="d-flex mb-2">
                  <label>Telefone 2:</label>
                  <MaskedField
                    className="ant-input"
                    name="condutor_telefone_2"
                    type="text"
                    mask={phoneMask()}
                  />
                </div>
              </Col>
            </Row>
          </div>
        </div>
        <br />
        <div className="filtro__info_container filtro_proprietario">
          <div className="filtro__title">Informações do Proprietário</div>
          <div className="p-2">
            <Row gutter={8}>
              <Col span={12}>
                <div className="d-flex mb-2">
                  <label>Nome:</label>
                  <Input
                    className="ant-input"
                    name="proprietario_nome"
                    type="text"
                  />
                </div>
                <div className="d-flex mb-2">
                  <label>Endereço:</label>
                  <Input
                    className="ant-input"
                    name="proprietario_rua"
                    type="text"
                  />
                </div>
                <div className="d-flex mb-2">
                  <label>Complemento:</label>
                  <Input
                    className="ant-input"
                    name="proprietario_complemento"
                    type="text"
                  />
                </div>
                <div className="d-flex mb-2">
                  <label>Cidade:</label>
                  <Input
                    className="ant-input"
                    name="proprietario_cidade"
                    type="text"
                  />
                </div>
                <div className="d-flex mb-2">
                  <label>CEP:</label>
                  <MaskedField
                    className="ant-input"
                    name="proprietario_cep"
                    type="text"
                    mask={cepMask()}
                    customfunction={event =>
                      this.handleCepInformations(event, "proprietario")
                    }
                  />
                </div>
              </Col>
              <Col span={12}>
                <div className="d-flex mb-2">
                  <label>CPF/CNPJ:</label>
                  <MaskedField
                    className="ant-input"
                    name="proprietario_cpf_cnpj"
                    type="text"
                    mask={this.state.mask_cpf_prop}
                    customfunction={event => this.handlePropCpfCnpj(event)}
                  />
                </div>
                <div className="d-flex mb-2">
                  <label>Nº:</label>
                  <Input
                    className="ant-input"
                    name="proprietario_numero"
                    type="text"
                  />
                </div>
                <div className="d-flex mb-2">
                  <label>Bairro:</label>
                  <Input
                    className="ant-input"
                    name="proprietario_bairro"
                    type="text"
                  />
                </div>
                <div className="d-flex mb-2">
                  <label>UF:</label>
                  <Input
                    className="ant-input"
                    name="proprietario_uf"
                    type="text"
                  />
                </div>
                <div className="d-flex mb-2">
                  <label>Telefone 1:</label>
                  <MaskedField
                    className="ant-input"
                    name="proprietario_telefone_1"
                    type="text"
                    mask={phoneMask()}
                  />
                </div>
                <div className="d-flex mb-2">
                  <label>Telefone 2:</label>
                  <MaskedField
                    className="ant-input"
                    name="proprietario_telefone_2"
                    type="text"
                    mask={phoneMask()}
                  />
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Filtro/components/Verde/BForm.js